import { RefObject, useEffect, useState } from 'react';

/**
 * Tracks an element's rendered height, e.g. to stack sticky elements below it.
 *
 * Read from getBoundingClientRect rather than offsetHeight: rem sizes resolve
 * to fractional pixels below 1900px, and a rounded-down height would leave a
 * sliver between stacked sticky elements for scrolled content to show through.
 */
export const useElementHeight = (ref: RefObject<HTMLElement>) => {
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const element = ref.current;
    if (!element) {
      return;
    }

    const resizeObserver = new ResizeObserver(() => {
      setHeight(element.getBoundingClientRect().height);
    });
    resizeObserver.observe(element);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return height;
};
